import React from 'react';

export default function Select({
    label,
    hint,
    options = [],
    placeholder,
    className = '',
    ...props
}) {
    return (
        <div className={className}>
            {label && (
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    {label}
                    {hint && <span className="text-xs text-gray-400 font-normal ml-1.5">{hint}</span>}
                </label>
            )}
            <select
                className="h-9 w-full rounded-md border border-gray-200 bg-white px-3 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-1 disabled:bg-gray-50 disabled:text-gray-500"
                {...props}
            >
                {placeholder && <option value="">{placeholder}</option>}
                {options.map((opt) => {
                    const val = typeof opt === 'string' ? opt : opt.value;
                    const lbl = typeof opt === 'string' ? opt : opt.label;
                    return <option key={val} value={val}>{lbl}</option>;
                })}
            </select>
        </div>
    );
}
